import { createContext } from "react";

type AlertVariant = "neutral" | "success" | "error" | "warning" | "info";

export type AlertContextType = {
  variant: AlertVariant;
};

export const AlertContext = createContext({} as AlertContextType);
